import { render } from "./PortalMain.vue?vue&type=template&id=3ffc606e&scoped=true"
import script from "./PortalMain.vue?vue&type=script&lang=js"
export * from "./PortalMain.vue?vue&type=script&lang=js"

import "./PortalMain.vue?vue&type=style&index=0&id=3ffc606e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffc606e"]])

export default __exports__